import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Container } from 'react-grid-system'

import Logo from 'assets/svg/logo.svg'

import './Footer.scss'

const Footer = () => {

    const scrollTop = () => {
        window.scroll({ left: 0, top: 0, behavior: 'smooth' })
    }

    return (
        <>
            <div className="footer">
                <Container className="footer__container">
                    <Col className="footer__wrap" sm={12}>
                        <Link className="footer__logo" id="logoFooter" to="/">
                            <img
                                onClick={scrollTop}
                                width={97}
                                src={Logo}
                                alt="Logotipo Alelo"
                            />
                        </Link>
                        <span className="footer__terms">
                            <span>
                                {' '}
                                Todos os direitos reservados. <br /> Copyright
                                2025 Alelo{' '}
                            </span>
                        </span>
                    </Col>
                </Container>
            </div>
        </>
    )
}

export default Footer
